module.exports = __webpack_public_path__ + "resources/image-74b5a891d329c8f66902e9b1b1d297c8.svg";